(function() {
    'use strict';

    angular.module('app.cuentasContables', []);
})();
